import * as React from 'react';
import { Input, Button, message, Radio, Result } from 'antd';
import "./login.scss";
import { requestLogin, requestSignup, resetPassword } from '../../model/api';


export default class Login extends React.Component {
    _email_reg = /^([a-zA-Z]|[0-9])(\w|\-|.)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
    constructor(props) {
        super(props);
        this.state = {
            showSignUp: false,
            showPasswordFind: false,
            showSignUpResult: false,
            resetPasswordResult: false,
            email: "",
            password: "",
            firstName: "",
            lastName: "",
            gender: 1,
            token: '',
            src: null
        }
        this.handleLogin = this.handleLogin.bind(this);
        this.handleSignUp = this.handleSignUp.bind(this);
        this.handleCheckEmail = this.handleCheckEmail.bind(this);
        this.setPassword = this.setPassword.bind(this)
    }

    handleLogin() {//登录
        const { email, password } = this.state;
        if (!email) {
            message.error("邮箱不能为空!");
            return;
        }
        if (!password) {
            message.error("密码不能为空!");
            return;
        }
        if (!email.match(this._email_reg)) {
            message.error("邮箱格式不正确!");
            return;
        }
        requestLogin(email, password).then(data => {
            if (data && data.status == true) {
                document.cookie = `Authorization=%22${data.token}%22;path=/`;
                localStorage.setItem("token_aminer", data.token);
                this.props.onClose && this.props.onClose();
            } else {
                message.error("账号密码校验失败!");
            }
        })
    }

    handleSignUp() {//注册
        const { email, firstName, lastName, gender } = this.state;
        if (!email) {
            message.error("邮箱不能为空!");
            return;
        }
        if (!firstName) {
            message.error("名不能为空!");
            return;
        }
        if (!lastName) {
            message.error("姓不能为空!");
            return;
        }
        if (!email.match(this._email_reg)) {
            message.error("邮箱格式不正确!");
            return;
        }
        requestSignup(email, firstName, lastName, gender).then(data => {
            if (data) {
                if (data.status == true) {
                    this.setState({ showSignUpResult: true });
                } else if (data.status == false) {
                    if (data.message == "user.exists") {
                        message.error("邮箱已存在!");
                    } else {
                        message.error("登陆失败!");
                    }
                }
            }
        })
    }
    setPassword() {

        const { email, password, src, token } = this.state;
        if (!email) {
            message.error("邮箱不能为空!");
            return;
        }
        resetPassword(email, password, src, this.state.token).then(data => {
            if (data) {
                if (data.status == true) {
                    this.setState({
                        resetPasswordResult: true,
                    });
                    console.log(this.state.resetPasswordResult)
                }
                else {
                    message.error('重置失败')
                }
            }
        })
    }
    handleCheckEmail() {
        let arr = this.state.email.split("@");
        let url = `http://mail.${arr[arr.length - 1]}`;
        window.open(url, "_blank");
    }

    render() {
        return (
            <div className="login">
                <div className='bg' onClick={() => this.props.onClose && this.props.onClose()} />
                {
                    this.state.showSignUpResult && (
                        <div className="panel">
                            <Result
                                status="success"
                                title="注册成功，请前往校验邮箱！"
                                extra={[
                                    <Button className='result_btn' key="console" onClick={() => this.setState({ showSignUp: false, showSignUpResult: false })}>
                                        完成
                                    </Button>,
                                    <Button className='result_btn' type="primary" key="buy" onClick={this.handleCheckEmail}>校验</Button>
                                ]} />
                        </div>
                    )
                }
                {
                    this.state.resetPasswordResult && (
                        <div className="otherPanel">
                            <Result
                                status="success"
                                title="邮件已发送，请前往校验邮箱！"
                                extra={[
                                    <Button className='result_btn' key="console" onClick={() => this.setState({ resetPasswordResult: false })}>
                                        完成
                                    </Button>,
                                    <Button className='result_btn' type="primary" key="buy" onClick={this.handleCheckEmail}>校验</Button>
                                ]} />
                        </div>
                    )
                }
                {
                    !this.state.showSignUpResult && this.state.showSignUp && (//注册
                        <div className="panel">
                            <Input className="input first" placeholder="邮箱" onChange={(e) => this.setState({ email: e.target.value })} value={this.state.email} />
                            <Input className="input other" placeholder="名" onChange={(e) => this.setState({ firstName: e.target.value })} value={this.state.firstName} />
                            <Input className="input other" placeholder="姓" onChange={(e) => this.setState({ lastName: e.target.value })} value={this.state.lastName} />
                            <Radio.Group className='gender' onChange={(e) => this.setState({ gender: e.target.value })} value={this.state.gender} >
                                <Radio value={1}>男</Radio>
                                <Radio value={2}>女</Radio>
                            </Radio.Group>
                            <Button className='btn' onClick={this.handleSignUp}>注册</Button>
                            <div className='tip' onClick={() => this.setState({ showSignUp: false })}>返回登陆</div>
                        </div>
                    )
                }
                {
                    !this.state.showSignUpResult && !this.state.showSignUp && (//登录
                        <div className="panel">
                            <Input className="input username" placeholder="邮箱" onChange={(e) => this.setState({ email: e.target.value })} value={this.state.email} />
                            <Input className="input password" type="password" placeholder="密码" onChange={(e) => this.setState({ password: e.target.value })} value={this.state.password} onPressEnter={this.handleLogin} />
                            <Button className='btn' onClick={this.handleLogin}>登陆</Button>
                            <div className='forgotPassaword' onClick={() => this.setState({ showPasswordFind: true })}>忘记密码</div>
                            <div className='tip' onClick={() => this.setState({ showSignUp: true })}>注册</div>
                        </div>
                    )
                }
                {
                    !this.state.showSignUpResult && this.state.showPasswordFind && (//忘记密码
                        <div className="panel">
                            <div className="box">
                            </div>
                            <Input className="input username" placeholder="邮箱" onChange={(e) => this.setState({ email: e.target.value })} value={this.state.email} />
                            <Button className='btn' onClick={this.setPassword}>重置密码</Button>
                            <div className='register' onClick={() => this.setState({ showSignUp: true, showPasswordFind: false })}>注册</div>
                            <div className='loginIn' onClick={() => this.setState({ showSignUp: false, showPasswordFind: false })}>登陆</div>
                        </div>
                    )
                }
            </div>
        )
    }
}